import React from "react";
import { Link } from "react-router-dom";
import "../Styles/CTASection.css";

function CTASection() {
  return (
    <section className="cta-section">
      <div className="cta-inner">
        <h2>Ready to Start Your Project?</h2>
        <p>
          Get a free, no-obligation estimate today. Let us bring your vision to
          life with professional craftsmanship.
        </p>
        <div className="cta-buttons">
          <Link to="/contact-us" className="cta-btn-primary">
            Get Free Estimate
          </Link>
          <a href="tel:+12396012421" className="cta-btn-secondary">
            Call: 239-601-2421
          </a>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
